/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{getDefaultExportFromCjs as l}from"../../_virtual/_commonjsHelpers.js";function n(l,n,u){var t,e,o,r,a;function i(){var c=Date.now()-r;c<n&&c>=0?t=setTimeout(i,n-c):(t=null,u||(a=l.apply(o,e),o=e=null))}null==n&&(n=100);var c=function(){o=this,e=arguments,r=Date.now();var c=u&&!t;return t||(t=setTimeout(i,n)),c&&(a=l.apply(o,e),o=e=null),a};return c.clear=function(){t&&(clearTimeout(t),t=null)},c.flush=function(){t&&(a=l.apply(o,e),o=e=null,clearTimeout(t),t=null)},c}n.debounce=n;var u=l(n);export{u as default};
//# sourceMappingURL=index.js.map
